import type { FunctionComponent } from "react";
import { HeartIcon, ArrowDownTrayIcon } from "@heroicons/react/20/solid"; // Assuming you want to use a heart icon for favorites or likes

interface TemplateCardProps {
    title: string;
    imageUrl: string;
    description: string;
}

const TemplateCard: FunctionComponent<TemplateCardProps> = ({ title, imageUrl, description }) => {
  return (
    <li className="max-w-sm rounded overflow-hidden shadow-lg flex flex-col justify-between">
        <div>
            <img 
              className="w-full" 
              src={imageUrl} 
              alt={`Template - ${title}`} 
              width={300}  
              height={300} 
              />
            <div className="px-6 py-4">
                <h3 className="font-bold text-xl mb-2">{title}</h3>
                <p className="text-gray-700 text-base">{description}</p>
            </div>
        </div>
        <div className="px-6 pt-4 pb-2 flex justify-between items-center">
            <button className="bg-sky-500 hover:bg-sky-700 text-white font-bold py-2 px-4 rounded inline-flex items-center">
                <ArrowDownTrayIcon className="w-4 h-4 mr-2" />
                <span>Download</span>
            </button>
            <button className="inline-flex items-center">
                <HeartIcon className="h-6 w-6 text-red-200 hover:text-red-500" />
            </button>
        </div>
    </li>
  );
};

export default TemplateCard;
